export const buttons = {
  exportCSV: {
    label: 'Exportar CSV',
  },
  exportPDF: {
    label: 'Exportar PDF',
  },
  allData: {
    label: 'Todos',}
};